/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsHoop,
    AssetsMelcoModelsHoopFromJSON,
    AssetsMelcoModelsHoopToJSON,
} from '../models';

export interface SyncHoopsApiSyncAssetHoopsRequest {
    version?: number;
    productList?: string;
}

export interface SyncHoopsApiSyncHoopsDownloadHoopRequest {
    id: string;
}

/**
 * 
 */
export class SyncHoopsApi extends runtime.BaseAPI {

    /**
     */
    async syncAssetHoopsRaw(requestParameters: SyncHoopsApiSyncAssetHoopsRequest): Promise<runtime.ApiResponse<Array<AssetsMelcoModelsHoop>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sync/assets/hoops`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetsMelcoModelsHoopFromJSON));
    }

    /**
     */
    async syncAssetHoops(requestParameters: SyncHoopsApiSyncAssetHoopsRequest): Promise<Array<AssetsMelcoModelsHoop>> {
        const response = await this.syncAssetHoopsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async syncHoopsDownloadHoopRaw(requestParameters: SyncHoopsApiSyncHoopsDownloadHoopRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling syncHoopsDownloadHoop.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sync/assets/hoops/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async syncHoopsDownloadHoop(requestParameters: SyncHoopsApiSyncHoopsDownloadHoopRequest): Promise<Blob> {
        const response = await this.syncHoopsDownloadHoopRaw(requestParameters);
        return await response.value();
    }

}
